import { call, take } from 'redux-saga/effects'

import { unsubscribeUser } from '../../api/api'
import { normalizeErrorResponse } from '../../util/errorUtils'
import { formSaga } from './sagas'

// ------------------------------------
// Action Types & Creators
// ------------------------------------
export const UNSUBSCRIBE = 'foodsby/unsubscribe/UNSUBSCRIBE'
export const UNSUBSCRIBE_SUCCESS = 'foodsby/unsubscribe/UNSUBSCRIBE_SUCCESS'
export const UNSUBSCRIBE_FAILURE = 'foodsby/unsubscribe/UNSUBSCRIBE_FAILURE'

export const triggerUnsubscribe = unsubscribeFormData => {
  return {
    type: UNSUBSCRIBE,
    unsubscribeFormData,
  }
}

export const unsubscribeSuccess = response => {
  return {
    payload: { response },
    type: UNSUBSCRIBE_SUCCESS,
  }
}

export const unsubscribeFailure = ({ response }) => {
  const error = normalizeErrorResponse(response, {
    notFound: 'A user with the provided email does not exist.',
  })
  return {
    payload: { error },
    type: UNSUBSCRIBE_FAILURE,
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UNSUBSCRIBE]: state => {
    return {
      ...state,
      error: undefined,
      submitting: true,
    }
  },
  [UNSUBSCRIBE_FAILURE]: (state, action) => {
    return {
      ...state,
      error: action.payload.error,
      submitting: undefined,
      success: undefined,
    }
  },
  [UNSUBSCRIBE_SUCCESS]: (state, action) => {
    const response = action.payload.response
    return {
      ...state,
      error: undefined,
      response,
      submitting: undefined,
      success: true,
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}

export default function unsubscribe(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// -----------------------------------
export function* watchTriggerUnsubscribe() {
  while (true) {
    const {
      unsubscribeFormData: { EmailAddress },
    } = yield take(UNSUBSCRIBE)
    yield call(
      formSaga,
      'unsubscribe',
      unsubscribeUser,
      [EmailAddress],
      unsubscribeSuccess,
      unsubscribeFailure,
    )
  }
}
